import styled from "styled-components";

import { LegalPathStyledProps as Props } from "./LegalPath.types";
import { CONSTANTS } from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { tablet } = BREAKPOINTS;

const LegalPathStyled = styled.div<Props>`
  .LegalPath {
    &__stepper {
      display: flex;
      margin-bottom: 3.4rem;
      align-items: center;
      justify-content: center;

      @media (max-width: 1100px) {
        padding-top: 0;
      }

      @media (max-width: ${tablet}px) {
        margin: 2rem;
      }
    }

    &__step {
      width: 8.2rem;
      height: 0.6rem;
      background-color: var(--palette-gray-s0-l40-a40);
      margin-right: 0.6rem;
      margin-left: 0.6rem;
      border-radius: 1rem;

      @media (max-width: ${tablet}px) {
        width: 4.2rem;
        margin-right: 0.4rem;
        margin-left: 0.4rem;
      }

      &--active {
        background-color: var(--palette-primary);
      }
    }

    &__optionsContainer {
      display: flex;
      justify-content: space-between;
    }

    &__optionContainer {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 1.2rem;
    }

    &__goBack {
      cursor: pointer;
      margin-bottom: 1.2rem;
    }

    &__closeModal {
      cursor: pointer;
    }

    &__title {
      color: var(--palette-black);
      font-size: 2.8rem;
      font-weight: 600;
    }

    &__buttonContainer {
      border-top: 0.1rem solid var(--palette-gray-s0-l80);
      padding: 2rem 4.8rem;
      padding-bottom: 0;
      margin-top: 1rem;
      display: flex;
      justify-content: flex-end;
    }

    &__button {
      padding: 1.2rem 5.2rem;
      justify-self: flex-end;
    }
  }
`;

export default LegalPathStyled;
